import { Directive, QueryList, ContentChildren, ElementRef } from '@angular/core';
import { MatSelect } from '@angular/material/select';

import { MatOption } from '@angular/material/core';

@Directive({
  selector: '[appMatOptionHeight]',
})
export class MatOptionHeightDirective {
  @ContentChildren(MatOption, { read: ElementRef }) options: QueryList<ElementRef>;
  
  constructor(
    public matSelect: MatSelect
  ) {
    // Override the standard item height calculation for scroll positioning to use
    // a hard-set 2.5 multiplier to the _triggerFontSize, since we are using a smaller
    // size font than standard Material design the default multiplier of 3 causes it
    // to scroll too far when the option list is long.
    (<any> this.matSelect)._getItemHeight = () => this.matSelect._triggerFontSize * 2.5;
  }
}